// extracted by mini-css-extract-plugin
module.exports = {"previewsContainer":"video-previews_previewsContainer__3d0qM","previewContainer":"video-previews_previewContainer__15g3x"};